export const CANCEL_RETURN_ACTION_TYPE = 'Cancel return';
export const PROCESS_RETURN_ACTION_TYPE = 'Process return';
